import { render, staticRenderFns } from "./IntentForm.vue?vue&type=template&id=23d7796a&scoped=true&"
import script from "./IntentForm.vue?vue&type=script&lang=js&"
export * from "./IntentForm.vue?vue&type=script&lang=js&"
import style0 from "./IntentForm.vue?vue&type=style&index=0&id=23d7796a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7796a",
  null
  
)

export default component.exports